export default {
    meta: { title: '关于我们' },
};
